import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** https://jira.vk.team/browse/CLOUDWEB-17704 Фильтрация пабликов в документах. Только ваши */
export const ONLY_YOURS_ALLDOCS_CATEGORY_ENABLED = isFeature('only-yours-alldocs-category-enabled');
